import React from "react";
import AboutWrapperArea from "./AboutWrapperArea";

function About() {
  return (
    <>
      <section className="info-bg section-bottom-pad"><AboutWrapperArea/></section>
    </>
  );
}

export default About;
